import styled from 'styled-components';

import { LinkButton } from 'approot/shared/styles/buttons/link-button.style';
import { grey7 } from 'approot/shared/styles/colours.style';
import { font14 } from 'approot/shared/styles/typography.style';

export const FeedbackButton = styled(LinkButton)`
  ${font14}
  color: ${grey7};
`;
